module.exports = __webpack_public_path__ + "photo_1.jpg?7d2e51c69be9fe44c9c25e646d0a2f10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo_1.jpg
// module id = 25
// module chunks = 0